import React from "react";
import { useSettings } from "@/contexts/SettingsContext";

export default function AboutSection() {
  const { settings } = useSettings();
  return (
    <section data-testid="about-section" className="py-16 md:py-32 border-t border-[color:var(--border)]">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-4">
            <div className="eyebrow">About the Agency</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight">
              {settings.about_heading}
            </h2>
            <p className="mt-8 text-lg md:text-xl text-[color:var(--text-muted)] leading-relaxed max-w-2xl">
              {settings.about_body}
            </p>

            <div className="mt-12 grid grid-cols-3 gap-6 md:gap-10">
              {[
                ["Design", "Every element considered."],
                ["Logistics", "Precise, invisible, on time."],
                ["Hospitality", "A guest experience that lingers."],
              ].map(([t, d]) => (
                <div key={t}>
                  <div className="font-display italic text-2xl md:text-3xl">{t}</div>
                  <p className="mt-2 text-sm text-[color:var(--text-muted)]">{d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
